// @ts-nocheck
import { plugin } from './plugin';
import * as Plugin_0 from '../../app.tsx';
import * as Plugin_1 from '@@/plugin-keep-alive/runtime';
import * as Plugin_2 from '@@/plugin-keep-alive/fixCustomizedRuntime';
import * as Plugin_3 from '/aoneci/runner/work/source/packages/commerce/src/.umi-production/plugin-access/rootContainer.ts';
import * as Plugin_4 from '../plugin-initial-state/runtime';
import * as Plugin_5 from '/aoneci/runner/work/source/packages/commerce/src/.umi-production/plugin-locale/runtime.tsx';
import * as Plugin_6 from '../plugin-model/runtime';

  plugin.register({
    apply: Plugin_0,
    path: '../../app.tsx',
  });
  plugin.register({
    apply: Plugin_1,
    path: '@@/plugin-keep-alive/runtime',
  });
  plugin.register({
    apply: Plugin_2,
    path: '@@/plugin-keep-alive/fixCustomizedRuntime',
  });
  plugin.register({
    apply: Plugin_3,
    path: '/aoneci/runner/work/source/packages/commerce/src/.umi-production/plugin-access/rootContainer.ts',
  });
  plugin.register({
    apply: Plugin_4,
    path: '../plugin-initial-state/runtime',
  });
  plugin.register({
    apply: Plugin_5,
    path: '/aoneci/runner/work/source/packages/commerce/src/.umi-production/plugin-locale/runtime.tsx',
  });
  plugin.register({
    apply: Plugin_6,
    path: '../plugin-model/runtime',
  });

export const __mfsu = 1;
